import React, { useState } from "react";
import { useClubTenderActions } from "../../hooks/clubtender/useClubTenderActions";
import RequestConfirmDialog from "./RequestConfirmDialog";

/**
 * The one Reactivate control the archived LIST surfaces share: the compact
 * button in the collapsed row's actions column (handoff list row) and the
 * full-size one in the expanded panel are the same component, so both always
 * open the same handoff confirm and fire the same shared transition
 * (useClubTenderActions.reactivateRequest — toast, then the parent's refetch
 * moves the row back to Active and updates the counters).
 *
 * `size="sm"` is the row-cell fit; the default matches the platform's 44px
 * action buttons.
 */
const ReactivateRequestButton = ({ tender, onChanged = null, size = "md" }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const { draftLoading, reactivateRequest } = useClubTenderActions(tender, {
    onChanged,
  });

  return (
    <>
      <button
        type="button"
        onClick={(event) => {
          // The collapsed row toggles its panel on click; the button must not.
          event.stopPropagation();
          setShowConfirm(true);
        }}
        disabled={draftLoading}
        className={
          size === "sm"
            ? "rounded-lg border border-[#E6E6E6] bg-white px-3 py-1.5 text-[13px] font-medium text-[#1E1E1E] hover:bg-gray-50 disabled:opacity-50 whitespace-nowrap"
            : "min-h-[44px] rounded-lg border border-[#E6E6E6] bg-white px-4 text-sm font-medium text-[#1E1E1E] hover:bg-gray-50 disabled:opacity-50"
        }
      >
        Reactivate
      </button>
      <RequestConfirmDialog
        isOpen={showConfirm}
        title="Reactivate this request?"
        body="It goes live again, agents are notified, and fresh timers start."
        confirmLabel="Reactivate"
        loading={draftLoading}
        onClose={() => setShowConfirm(false)}
        onConfirm={async () => {
          const ok = await reactivateRequest();
          if (ok !== false) setShowConfirm(false);
        }}
      />
    </>
  );
};

export default ReactivateRequestButton;
